// STEP STUDIO-OVERLAY-MOBILE-FINAL-FIX-1 · 판매자 미리보기 전용 샘플 (서버 저장 · 송출 반영 없음).
//   기존 테스트 상품 샘플(1·2번 · 샘플 사이즈표 · picsum 이미지)과 동일 데이터.
const SAMPLE_SIZE_TABLE = {
  columns: ['사이즈', '총장', '가슴'],
  rows: [['S', '62', '48'], ['M', '64', '51'], ['L', '66', '54']],
  guide_text: '',
  material: '면 80%, 폴리 20%',
  etc: '신축성 좋음 / 비침 없음',
};

export const SAMPLE_PRODUCT = {
  product_id: 'preview_sample_1', slot_number: 1, name: '1번 · 스트라이프 니트', sale_price: 39000,
  image: 'https://picsum.photos/seed/livemoa_test_1/300/300', size_table: SAMPLE_SIZE_TABLE, __sample: true,
};

export const SAMPLE_PAST_PRODUCT = {
  product_id: 'preview_sample_2', slot_number: 2, name: '2번 · 데님 팬츠', sale_price: 45000,
  image: 'https://picsum.photos/seed/livemoa_test_2/300/300', __sample: true,
};

export { SAMPLE_SIZE_TABLE };

export const SAMPLE_NOTICE_IMAGE = `data:image/svg+xml;utf8,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="200"><rect width="400" height="200" rx="16" fill="#FF3B30"/>'
  + '<text x="200" y="95" font-size="34" font-weight="900" fill="#fff" text-anchor="middle" font-family="sans-serif">공지 이미지</text>'
  + '<text x="200" y="140" font-size="22" font-weight="700" fill="#ffe1de" text-anchor="middle" font-family="sans-serif">미리보기 샘플</text></svg>',
)}`;

// STUDIO-NOTICE-TIMER-LAYOUT-FIX-1 · 공지 없을 때 배치 편집용 샘플 문구.
export const SAMPLE_NOTICE = { text: '공지 문구 미리보기 샘플\n방송 중 공지 내용이 여기에 표시돼요' };


export const sampleQrUrl = () => `${window.location.origin}/product/preview_sample_1`;
